export default __webpack_public_path__ + "static/narrative-109daaaa5e8d7dbbb48005b07969e020.jpg";